import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState, getLocalStorage } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { CertifyStatusEnum, Namespaces as commonNamespaces } from "@reco-w/common-models";
import { memberCompanyService } from "@reco-w/member-service";

import { Namespaces, operateSourceEnum } from "./common";
export namespace certifyCompanyModel {
    export const namespace = Namespaces.certifyCompany;

    export const state: any = freeze({
        ...CoreState,
    });
    export type StateType = typeof state;

    export const reducers: ReducersMapObject = {
        ...CoreReducers,

        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,

        *initPage({ message, inputData, callback }, { call, put }) {
            put({ type: "showLoading" });
            try {
                yield put({ type: "input", data: { ...inputData } });
                yield put({ type: "getMember", message, callback });
            } catch (e) {
                yield call(message!.error, "initPage：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 校验统一社会信用代码
         * @param { message, creditCode, callback }
         * @param { call }
         */
        *validateCreditcode({ message, creditCode, callback }, { call }) {
            try {
                const result = yield call(memberCompanyService.validateCreditcode, { creditCode });

                if (callback) {
                    yield call(callback, result);
                }
            } catch (e) {
                yield call(message!.error, e.errmsg);
            }
        },

        *getMember({ message, callback }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, message });
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCurrentUser`, message });
                const mymenuState: any = yield select((state) => state[commonNamespaces.memberCommon]),
                    member = mymenuState.member,
                    user = mymenuState.user;
                if (member && member.status === CertifyStatusEnum.allow) yield put({ type: "input", data: { submitSuccess: true } });

                yield put({
                    type: "input",
                    data: {
                        Account: user && user.currentUser,
                        realname: (user && user.currentUser && user.currentUser.realName) || "",
                        mobile: (user && user.currentUser && user.currentUser.mobile) || "",
                        currentUser: user && user.currentUser,
                        member,
                        company: member?.companyName,
                        creditCode: member?.creditCode,
                        companyaddress: member?.address,
                        userId: user && user.currentUser && user.currentUser.id,
                    },
                });

                if (callback) yield call(callback, member);
            } catch (e) {
                yield call(message!.error, "getMember：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 提交认证
         */
        *certify({ message, callback }, { call, put, select }) {
            try {
                yield put({ type: "showLoading" });
                yield yield put({ type: `${commonNamespaces.memberCommon}/cleanMemberInfo`, message });
                const state: any = yield select((state) => state[Namespaces.certifyCompany]);
                let params2 = {
                    accountId: state!.userId,
                    address: state!.companyaddress,
                    name: state!.company,
                    parkId: getLocalStorage("parkId"),
                    parkName: getLocalStorage("parkName"),
                    realName: state!.realname,
                    mobile: state!.mobile,
                    creditCode: state!.creditCode,
                    operateSource: operateSourceEnum.web,
                };
                const certify = yield call(memberCompanyService.post, params2);
                yield call(callback, certify);
            } catch (e) {
                yield call(message!.error, "certify：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 赋值附件
         * @param { message, data }
         * @param { call, put }
         */
        *generateAttach({ message, data }, { call, put }) {
            try {
                yield put({ type: "showLoading" });
                yield call(memberCompanyService.generateAttach, [data]);
            } catch (e) {
                yield call(message!.error, "generateAttach：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
    };
}
app.model(certifyCompanyModel);
